import {
  FaFileAlt,
  FaChartLine,
  FaClock,
} from "react-icons/fa";

export const mobileAppData = [
  {
    image: "/assets/images/mobile1.png",
    size: "small",
    topFeature: {
      icon: FaFileAlt,
      text: "mobileApp.requests",
    },
  },

  {
    image: "/assets/images/mobile2.png",
    size: "large",
    bottomFeature: {
      icon: FaClock,
      text: "mobileApp.workflow",
    },
  },

  {
    image: "/assets/images/mobile3.png",
    size: "small",
    topFeature: {
      icon: FaChartLine,
      text: "mobileApp.salary",
    },
  },
];